import React, { useState, useEffect } from 'react';
import Head from 'next/head'
import { APIURL, PAGEURL } from './../../constants'
import services from './../../components/services'
import Link from 'next/link'
import BottomNav from './../../components/common/BottomNav.js'
import { BsReply } from '@react-icons/all-files/bs/BsReply'
import Image from 'next/image'
import { getBlogSeo } from '../../utils/contentSeo'
import { blogPathSlug, blogPathToLookupTitle } from '../../utils/blogUrls'


function BlogComponent(props) {
  const blogTitle = props.title;
  const blog = props.blog;
  const seo = getBlogSeo(blogTitle) || {}
  const pageTitle = seo.title || blogTitle
  const pageDescription = seo.description || blog.description
  const [linkIndex, setLinkIndex] = React.useState([]);
  const [closeSidebar, setCloseSidebar] = React.useState(false)
  useEffect(() => {
    if (!blog || typeof document === 'undefined') return undefined
    let index = []
    let elements = document.getElementsByClassName('section')
    for (let i = 0; i < elements.length; i++) {
      let section = elements[i]
      let section_id = 'section-'+i
      section.setAttribute('id', section_id)
      let header = section.getElementsByClassName('section-header')
      if (header.length > 0) {
        index.push(<div className='header'><a onClick={()=>{setCloseSidebar(true)}} href={'#'+section_id}>{header[0].innerText}</a></div>)
      }
      let sub_headers = section.getElementsByClassName('section-sub-header')
      for (let j = 0; j < sub_headers.length; j++) {
        let sub_header = sub_headers[j]
        let sub_section_id = 'sub-section-'+i + '-' + j
        sub_header.setAttribute('id', sub_section_id)
        index.push(<div className='sub-header'><a onClick={()=>{setCloseSidebar(true)}} href={'#'+sub_section_id}>{sub_header.innerText}</a></div>)
      }
    }
    setLinkIndex(index)
    return undefined
  }, [blog])

  const { content, image, title, created_at, description, topic_slugs, topic_names } = blog
  let psg = []
  for (let i in topic_slugs) {
    psg.push(
      <div key={'psg-'+i} className="product-container">
        <Link href={PAGEURL.PRODUCT_PICKER(topic_slugs[i], '0')}>
            <div className="product-option">
              {topic_names[i]}
            </div>
        </Link>
      </div>
    )
  }

  let navTabs = {}
  if (linkIndex.length > 0) {
    navTabs['jump_to'] = {
      label: 'Jump To',
      logo: (<BsReply key={'jump-to'}/>),
      content: [
        <div key={'jump-to1'} className="overflow-container sidebar-jump-to">
          {linkIndex}
        </div>
      ]
    }
  }
  if (psg) {
    navTabs['psgs'] = {
      label: 'Product Pickers',
      logo: (<div key={'psg'} className='img' />),
      content: [
        <div key={'psg1'} className="psg-container pt-lg">
          Product Pickers
          <div className="products-flex">
            {psg}
          </div>
        </div>
      ]
    }
  }

  const ctaTopic = seo.ctaTopic || (topic_slugs && topic_slugs[0])
  const ctaLabel = seo.ctaLabel || (topic_names && topic_names[0]
    ? `${topic_names[0]} Picker`
    : 'Product Picker')

  return (
    <div className="home home-blog">
      <Head>
        <title>{pageTitle}</title>
        <meta name='description' content={pageDescription}/>
      </Head>
      {Object.keys(navTabs).length > 0 && (
        <BottomNav
          height={"20%"}
          close={closeSidebar}
          setCloseFalse={setCloseSidebar}
          tabs={navTabs}
          default={null}
        >
        </BottomNav>
      )}
      <div className="blog-title-block">
        <div>
          <h1 className="title-left">
            {title}
          </h1>
          <div className="created-at">
            {created_at}
          </div>
        </div>
        <div className="image-right">
          <Image
            src={image}
            alt={title}
            width={768}
            height={384}
            priority={true}
          />
        </div>
      </div>
      <div className="blog-container">
        <div className="blog-post">
          <div className="blog" dangerouslySetInnerHTML={{ __html: content }} ></div>
          {ctaTopic && (
            <div className="blog pt-md">
              Ready for a personalized match? Try the{' '}
              <Link href={PAGEURL.PRODUCT_PICKER(ctaTopic, '0')}>
                <span className="orange-link">{ctaLabel}</span>
              </Link>
              {' '}— free recommendations in a couple of minutes.
            </div>
          )}
        </div>
        <div className="blog-post-right">
        <div className="psg-container">
          Product Pickers
          <div className="products-flex">
            {psg}
          </div>
        </div>
          <div className="link-index">
            <div className="jump-to">Jump To</div>
            {linkIndex}
          </div>
        </div>
      </div>
    </div>
  )
}

export async function getServerSideProps(context) {
  const { title } = context.query;
  const raw = Array.isArray(title) ? title[0] : title
  if (!raw) {
    return { notFound: true }
  }

  if (raw.endsWith('?') || /%3F$/i.test(raw)) {
    const cleanSlug = blogPathSlug(blogPathToLookupTitle(raw))
    return {
      redirect: {
        destination: `/blog/${cleanSlug}`,
        permanent: true,
      },
    }
  }

  try {
    const lookupTitle = blogPathToLookupTitle(raw)
    const response = await services.get_v2(APIURL.GET_BLOG_POSTS, {
      params: { title: lookupTitle }
    });
    if (response.status && response.status === 'failure') {
      return {
         notFound: true,
       }
    } else {
       return {
         props: {
           title: response.title,
           blog: response,
         },
       }
    }
  } catch (error) {
    return {
      notFound: true,
    };
  }
}

export default BlogComponent
